import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useFetchPort } from "@/port/use-fetch-port";
import { useFetchCustomFields } from "@/custom-fields/use-fetch-custom-fields";

export function DataFetcher(): null {
  const auth = useAuth();
  const fetchPort = useFetchPort();
  const fetchCustomFields = useFetchCustomFields();

  useEffect(() => {
    if (!auth.isAuthenticated) return;

    void fetchPort();
    void fetchCustomFields();
  }, [auth.isAuthenticated, fetchPort, fetchCustomFields]);

  return null;
}
